import type { EthereumProvider as EthereumProviderType } from "@manifoldxyz/frontend-provider-types";

declare global {
  interface Window {
    ManifoldEthereumProvider: typeof EthereumProviderType;
  }
}

export const EthereumProvider = window.ManifoldEthereumProvider;
